import React from 'react';
import Home from './pages/Home';

const App: React.FC = (): JSX.Element | null => <Home />;

export default App;
